import {
  STATUS_INFO_MAP,
  DEFAULT_STATUS_INFO,
  RESULT_VALUES,
  STATUS_VALUES,
} from '../constants/topFiveConstants';

export const getStatusInfo = (
  status?: string | number | null,
  result?: string | number | null
) => {
  // Priority: result over status
  if (result !== null && result !== undefined) {
    // Handle string values
    if (typeof result === 'string' && result in STATUS_INFO_MAP) {
      return STATUS_INFO_MAP[result as keyof typeof STATUS_INFO_MAP];
    }
    // Handle numeric values (legacy support)
    if (result === 1 || result === '1')
      return STATUS_INFO_MAP[RESULT_VALUES.PASS];
    if (result === 2 || result === '2')
      return STATUS_INFO_MAP[RESULT_VALUES.FAIL];
    if (result === 3 || result === '3')
      return STATUS_INFO_MAP[RESULT_VALUES.NA];
  }

  // Fallback to status
  if (status !== null && status !== undefined) {
    // Handle string values
    if (typeof status === 'string' && status in STATUS_INFO_MAP) {
      return STATUS_INFO_MAP[status as keyof typeof STATUS_INFO_MAP];
    }
    // Handle numeric values (legacy support)
    if (status === 1 || status === '1')
      return STATUS_INFO_MAP[STATUS_VALUES.GREEN];
    if (status === 2 || status === '2')
      return STATUS_INFO_MAP[STATUS_VALUES.ORANGE];
    if (status === 3 || status === '3')
      return STATUS_INFO_MAP[STATUS_VALUES.RED];
  }

  // Default fallback
  return DEFAULT_STATUS_INFO;
};
